import { render, staticRenderFns } from "./enaqbutton.vue?vue&type=template&id=48647e1a&scoped=true&"
import script from "./enaqbutton.vue?vue&type=script&lang=js&"
export * from "./enaqbutton.vue?vue&type=script&lang=js&"
import style0 from "./enaqbutton.vue?vue&type=style&index=0&id=48647e1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48647e1a",
  null
  
)

export default component.exports